export default __webpack_public_path__ + "static/media/cakes.58047fa4.jpg";